import { NavLink, useLocation } from "react-router-dom";
import { usePrefs } from "../lib/prefs";
import { useNavItems, useSettingsItems } from "./Layout";

/**
 * SettingsNav: the menu beside every setup page (company, channels, bookings,
 * security, your account), plus any work page someone hid from their sidebar,
 * so a hidden page is still one click away.
 */
export function SettingsNav() {
  const items = useSettingsItems();
  const { prefs } = usePrefs();
  const hidden = useNavItems().filter((i) => i.key !== "settings" && (prefs.hidden ?? []).includes(i.key));
  const groups: string[] = [];
  for (const i of items) if (!groups.includes(i.group)) groups.push(i.group);
  return (
    <nav className="settings-nav" aria-label="Settings">
      <p className="settings-nav-title">Settings</p>
      {groups.map((g) => (
        <div key={g} className="settings-nav-group">
          <span className="settings-nav-head">{g}</span>
          {items.filter((i) => i.group === g).map((i) => <NavLink key={i.key} to={i.to} end={i.end}>{i.label}</NavLink>)}
        </div>
      ))}
      {hidden.length > 0 && (
        <div className="settings-nav-group">
          <span className="settings-nav-head">Hidden from your sidebar</span>
          {hidden.map((i) => <NavLink key={i.key} to={i.to} end={i.end}>{i.label}</NavLink>)}
        </div>
      )}
    </nav>
  );
}

/** useSettingsArea: whether the current page is a setup page (or a page
 *  hidden from the sidebar), so it shows with the settings menu. */
export function useSettingsArea() {
  const { pathname } = useLocation();
  const { prefs } = usePrefs();
  const setup = useSettingsItems();
  const work = useNavItems();
  const under = (to: string, end?: boolean) => (end ? pathname === to : pathname === to || pathname.startsWith(to + "/"));
  if (setup.some((i) => under(i.to, i.end))) return true;
  return work.some((i) => i.key !== "settings" && (prefs.hidden ?? []).includes(i.key) && under(i.to, i.end));
}
